import React, { Component, Fragment } from "react";
import { CustomInput, Input, Alert } from "reactstrap";
import { NumberFormatInput } from "../../NumberFormatInput/NumberFormatInput";
import classnames from "classnames";
import style from "./OrderQuantityToTradesAssignment.module.scss";
import { Field } from "../Order/Field/Field";
import * as TradeItemUI from "../../Order/Item";

const ItemRow = ({ trade, id, actions, enabled, title = "", dayInfo, ...props }) => {
  return (
    <React.Fragment>
      {title !== "" ? <div>{title}</div> : null}
      <div className={`${style.item} ${enabled ? style.active : ""}`}>
        <div className={style.fields}>
          {dayInfo.clientQtyToAssign > 0 && (
            <Field label="Client Qty">
              <NumberFormatInput
                type="text"
                customInput={Input}
                value={trade.assignedClientQty}
                disabled={!enabled}
                invalid={!!trade["error_assignedClientQty"]}
                onValueChange={(e) => actions.change(id, "assignedClientQty", e.value)}
                dataTypeDecimalName="quantity"
                placeholder="Client Qty"
              />
            </Field>
          )}
          {dayInfo.propQtyToAssign > 0 && (
            <Field label="Prop Qty">
              <NumberFormatInput
                type="text"
                customInput={Input}
                value={trade.assignedPropQty}
                disabled={!enabled}
                invalid={!!trade["error_assignedPropQty"]}
                onValueChange={(e) => actions.change(id, "assignedPropQty", e.value)}
                dataTypeDecimalName="quantity"
                placeholder="Prop Qty"
              />
            </Field>
          )}
          {dayInfo.tradingQtyToAssign > 0 && (
            <Field label="Trading Qty">
              <NumberFormatInput
                type="text"
                customInput={Input}
                value={trade.assignedTradingQty}
                disabled={!enabled}
                invalid={!!trade["error_assignedTradingQty"]}
                onValueChange={(e) => actions.change(id, "assignedTradingQty", e.value)}
                dataTypeDecimalName="quantity"
                placeholder="Trading Qty"
              />
            </Field>
          )}
          {dayInfo.errorQtyToAssign > 0 && (
            <Field label="Error Qty">
              <NumberFormatInput
                type="text"
                customInput={Input}
                value={trade.assignedErrorQty}
                disabled={!enabled}
                invalid={!!trade["error_assignedErrorQty"]}
                onValueChange={(e) => actions.change(id, "assignedErrorQty", e.value)}
                dataTypeDecimalName="quantity"
                placeholder="Error Qty"
              />
            </Field>
          )}
        </div>
        <div>{`(qty: ${trade.quantity})`}</div>
        <TradeDetail trade={trade} />
        {trade.error && (
          <Fragment>
            <hr />
            <Alert color="danger" className={style.alert}>
              {trade.error}
            </Alert>
          </Fragment>
        )}
      </div>
    </React.Fragment>
  );
};

export const TradeDetail = ({ trade }) => {
  return (
    <div className={classnames(style.order, `cls-${trade.info.TradeAssetClassForm}`)}>
      <div>
        <b>#{trade.tradeId}</b> {TradeItemUI.renderTradeSide(trade.info)}{" "}
        {TradeItemUI.renderTradeQuantity(trade.info)} {TradeItemUI.renderTradeSymbol(trade.info)}
        {" @ "}
        {TradeItemUI.renderTradePrice(trade.info)}
      </div>
    </div>
  );
};

export default ItemRow;
